import { render, staticRenderFns } from "./CreateDashboard.vue?vue&type=template&id=1363571f&scoped=true&"
import script from "./CreateDashboard.vue?vue&type=script&lang=js&"
export * from "./CreateDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CreateDashboard.vue?vue&type=style&index=0&id=1363571f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1363571f",
  null
  
)

export default component.exports